import type { Image as ImageType } from '@lib/types'
import type { Product } from '@lib/types/product'

import Images from '@components/product/ProductView/Images'

type Props = {
	currentImage?: ImageType
	productImages: Product['images']
	closeModal: () => void
	setCurrentImageHandler: (image: ImageType) => void
}

export default function WholePageModal({
	productImages,
	currentImage,
	closeModal,
	setCurrentImageHandler
}: Props) {
	return (
		<div className="absolute z-50">
			<div className="fixed inset-0 flex flex-col w-full h-full p-8 bg-white">
				<button
					type="button"
					aria-label="close"
					className="absolute z-20 p-6 text-2xl transition-colors duration-300 left-2 top-2 hover:text-bbx-spark"
					onClick={() => closeModal()}
				>
					<i className="fa-light fa-xmark" />
				</button>
				<Images
					productImages={productImages}
					currentImage={currentImage}
					setCurrentImageHandler={setCurrentImageHandler}
					fullScreen
				/>
			</div>
		</div>
	)
}
